import React, { FC, useEffect, useState } from 'react';
import { Loading } from 'components/atoms/loading';
import { SpaceIcon } from 'components/atoms/space-icon';

export const SettingupPhaseItem: FC<{
  timeUntilLoading: number;
  title: string;
}> = ({ timeUntilLoading, title }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(
      () => setIsLoading(false),
      timeUntilLoading,
    );

    return () => clearTimeout(timer);
  });

  return (
    <li>
      {isLoading ? <Loading size="small" /> : <SpaceIcon name={title} />}
      <span>{title}</span>
    </li>
  );
};
